import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { styled, withTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core';
import Tab from '@material-ui/core/Tab';
import ProfileMenu from './ProfileMenu';
var StyledTab = styled(withTheme(Tab))(function (props) {
  return {
    color: props.theme.palette.gray80.main,
    minWidth: 'auto'
  };
});

var styles = function styles(theme) {
  return {
    headerTab: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '0 10px',
      padding: '0 10px',
      height: '40px',
      '&.active': {
        paddingRight: 0,
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        '&  span': {
          color: "".concat(theme.palette.primary.main)
        },
        '& > .profile-menu': {
          display: 'flex',
          marginLeft: '12px'
        }
      },
      '& > .profile-menu': {
        display: 'none'
      },
      '& button': {
        minHeight: '40px important',
        margin: 0,
        padding: 0,
        '&:active': {
          backgroundColor: 'transparent !important'
        }
      }
    },
    label: {
      textTransform: 'none'
    }
  };
};

var HeaderTab = /*#__PURE__*/function (_Component) {
  _inherits(HeaderTab, _Component);

  var _super = _createSuper(HeaderTab);

  function HeaderTab() {
    _classCallCheck(this, HeaderTab);

    return _super.apply(this, arguments);
  }

  _createClass(HeaderTab, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          refreshUsers = _this$props.refreshUsers;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.headerTab, " ").concat(this.props.active ? 'active' : '')
      }, /*#__PURE__*/React.createElement(StyledTab, {
        label: this.props.label,
        className: classes.label,
        id: this.props.id,
        value: this.props.value,
        disableRipple: true,
        onClick: function onClick() {
          return _this.props.handleClick(_this.props.value);
        }
      }), /*#__PURE__*/React.createElement(ProfileMenu, {
        refreshUsers: refreshUsers
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return HeaderTab;
}(Component);

var _default = withStyles(styles)(HeaderTab);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledTab, "StyledTab", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/HeaderTab.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/HeaderTab.js");
  reactHotLoader.register(HeaderTab, "HeaderTab", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/HeaderTab.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/HeaderTab.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();